<template>
  <div>
    <div class="col-md-12">
      <div class="modal-body">
        <label>UserName</label>
        <input type="text" v-model="params.userName" class="form-control" />
        <label>Start Date</label>
        <input type="date" v-model="params.startDate" class="form-control" />
        <label>End Date</label>
        <input type="date" v-model="params.endDate" class="form-control" />
      </div>
      <div class="modal-footer">
        <button @click="getReportUser()" type="button" class="btn btn-secondary">Download Report</button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  authHeader,
  responseCheck,
  StatURL,
  downloadblob
} from '../../helper'
import instance from '../../helper/http'
export default {
  data() {
    return {
      params: {
        startDate: '',
        endDate: '',
        userName: ''
      }
    }
  },
  methods: {
    getReportUser() {
      let loader = this.$loading.show()
      instance
        .get(StatURL + 'customstat', {
          params: this.params,
          headers: authHeader(),
          responseType: 'blob'
        })
        .then(response => {
          downloadblob('userstat.txt', response.data, 'text/plain')
          loader.hide()
        })
        .catch(function (error) {
          loader.hide();
          responseCheck(error.response.status)
        })
    }
  }
}
</script>